import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsdate-picker',
	templateUrl:'./BSDatePickerPluginCompPage.html',
	styles: [],
	styleUrls:['./BSDatePickerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSDatePickerPluginCompPage
{
	mdContent_809 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.datepicker.BSDatePicker;
\`\`\``;
	mdContent_810 = `\`\`\`java
BSDatePicker()
\`\`\``;
	mdContent_811 = `\`\`\`java
BSDatePicker&lt;?&gt; dp = new BSDatePicker&lt;&gt;();
dp.setMinDate(2024, 1, 1);
dp.setMaxDate(2025, 12, 31);
dp.setNavigation("arrows");
\`\`\``;
}
